import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class UserAgentService {
  constructor() { }
  isMobileDevice(): boolean {
    const userAgent = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  }
}